import React from 'react';
import { ScoreContext, ScoreContextData } from 'src/providers/saaSScore/ScoreProvider';

export const useScoreContext = (): ScoreContextData => {
  return React.useContext<ScoreContextData>(ScoreContext);
};
